export default "__VITE_ASSET__BvXoJUC4__"